import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./CareerSearch.scss";
import Job from "./Job";
import Loader from "../../Loader/Loader";
import Select from "react-select";
import Fuse from "fuse.js";
import sectors from "./Sectors.js";
import classnames from "classnames";
import _ from "lodash";
import {
	updateVisitor,
	setUserInfo
} from "../../../actions/DataCol/userdataAction";

const search_options = {
	shouldSort: true,
	threshold: 0.3,
	location: 0,
	distance: 100,
	// maxPatternLength: 32,
	minMatchCharLength: 1,
	keys: [
		"title",
		"company"
		// "description",
	]
};

class CareerSearchKeyword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedSector: undefined,
			display_jobs: [],
			loading: false,
			hide_jobs: [], //Coach USA
			show_jobs: [], //Bombardier
			searchString: ""
		};
	}

	componentDidMount() {
		// Get query string

		this.getDataFromURL();
		// Set jobs
		this.setState({
			display_jobs: this.props.jobs
		});
		if (this.props.searchString !== undefined) {
			this.setState(
				{
					searchString: this.props.searchString
				},
				() => this.setInfo(this.state.searchString)
			);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// If jobs array changes, search the jobs again
		if (prevProps.jobs !== this.props.jobs) {
			this.setState({
				display_jobs: this.props.jobs
			});
		}

		if (
			this.state.searchString !== "" &&
			prevProps.jobs !== this.props.jobs
		) {
			this.searchJobs();
		}
	}

	componentWillUnmount() {
		this.props.resetToOriginalState();
	}

	setInfo = keyword => {
		var user = this.props.user;
		if (user && !_.isEmpty(user)) {
			user["jobInterests"]["keywords"].push(keyword);
			console.log(user);
			updateVisitor(user);
			this.props.setUserInfo(user);
		}
	};

	getDataFromURL = () => {
		// Get query from query string
		var queryString = this.props.location;
		if (queryString !== undefined) {
			queryString = queryString.replace("?", "");
			let pair = queryString.split("=");
			if (pair[0] === "query") {
				this.setState(
					{
						searchString: pair[1].split("+").join(" ")
					},
					() => this.searchJobs()
				);
			}
		}
	};

	handleChange = selectedSector => {
		this.setState({ selectedSector: selectedSector });
	};

	setSearchString = event => {
		if (
			event !== undefined &&
			event.target.value !== "" &&
			event.target.value !== undefined
		) {
			this.setState({
				searchString: event.target.value
			});
		} else {
			this.setState({
				searchString: "",
				display_jobs: this.props.jobs
			});
		}
	};

	searchJobs = () => {
		var fuse = new Fuse(this.props.jobs, search_options);
		var result = fuse.search(this.state.searchString);
		this.setState(
			{
				display_jobs: result
			},
			() => this.setInfo(this.state.searchString)
		);
	};

	returnJob = job => {
		// If sector is selected, show those jobs
		if (
			this.state.selectedSector !== undefined &&
			job.sectors.includes(this.state.selectedSector.label)
		) {
			return <Job key={job._id} job={job} />;
		}
		// If no sector, show all
		if (
			!this.state.selectedSector ||
			this.state.selectedSector.value === undefined
		) {
			return <Job key={job._id} job={job} />;
		}
	};

	render() {
		const { selectedSector } = this.state;

		if (this.props.jobs.length === 0 || this.state.loading === true) {
			return (
				<div
					className={classnames({
						[styles.JobsSplit]: this.props.splitScreen
					})}
				>
					<Loader />
				</div>
			);
		} else {
			return (
				<div
					className={classnames(
						{ [styles.JobsSplit]: this.props.splitScreen },
						styles.JobsBox
					)}
				>
					<div className={styles.searchBox}>
						<Select
							className={styles.select}
							value={selectedSector}
							onChange={this.handleChange}
							options={sectors}
						/>
						<div className={styles.searchbar}>
							{/* */}
							<input
								className="form-control"
								type="text"
								placeholder={"Search for jobs here..."}
								name="search"
								value={this.state.searchString}
								onChange={this.setSearchString}
							/>

							<button
								className="btn btn-outline-secondary"
								type="button"
								onClick={() => this.searchJobs()}
							>
								Search
							</button>
						</div>
					</div>
					<span className={styles.DisplayJobsBox}>
						{this.state.display_jobs.map(job => {
							if (this.state.hide_jobs.includes(job._id)) {
								return null;
							} else if (this.state.show_jobs.length === 0) {
								return this.returnJob(job);
							} else if (this.state.show_jobs.includes(job._id)) {
								return this.returnJob(job);
							}
							return null;
						})}
					</span>
				</div>
			);
		}
	}
}

function mapStateToProps(state) {
	return {
		user: state.user.user
	};
}

const actions = {
	setUserInfo
};

export default connect(
	mapStateToProps,
	actions
)(CareerSearchKeyword);



// WEBPACK FOOTER //
// ./src/components/pages/Careers/CareerSearchKeyword.js